import { useEffect, useState } from 'react';
import tenantApi from '../api/tenantApi';
import { MERCURY_TRIAL_TENANT, customerTrialStatus } from './mercuryCustomerTrial';
export { MERCURY_TRIAL_TENANT, hasCustomerTrialFeature } from './mercuryCustomerTrial';
const MAX_TIMER = 2147483647;
export default function useMercuryCustomerTrial(tenantId) {
  const [state, setState] = useState({ tenantId: null, tenant: null, status: 'loading' });
  useEffect(() => {
    let alive = true, timer;
    if (tenantId !== MERCURY_TRIAL_TENANT) return undefined;
    setState({ tenantId, tenant: null, status: 'loading' });
    Promise.resolve().then(() => tenantApi.getTenantById(tenantId)).then(result => {
      if (!alive) return;
      const tenant = result?.data;
      const status = customerTrialStatus(tenantId, tenant);
      setState({ tenantId, tenant: status === 'active' || status === 'legacy' ? tenant : null, status });
      if (status !== 'active') return;
      const end = tenant.customerTrial.endsAt;
      const expire = () => {
        if (!alive) return;
        const remaining = end - Date.now();
        if (remaining <= 0) setState({ tenantId, tenant: null, status: 'expired' });
        else timer = setTimeout(expire, Math.min(remaining, MAX_TIMER));
      };
      expire();
    }).catch(() => { if (alive) setState({ tenantId, tenant: null, status: 'unavailable' }); });
    return () => { alive = false; clearTimeout(timer); };
  }, [tenantId]);
  if (tenantId !== MERCURY_TRIAL_TENANT) return { tenantId, tenant: null, status: 'legacy' };
  if (state.tenantId !== tenantId) return { tenantId, tenant: null, status: 'loading' };
  // A rerender at/after the deadline cannot briefly expose a legacy trial while
  // waiting for the timeout callback (for example after a backgrounded tab).
  if (state.status === 'active' && customerTrialStatus(tenantId, state.tenant) !== 'active') {
    return { tenantId, tenant: null, status: 'expired' };
  }
  return state;
}
